"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHelp = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M12.75,15.9285714 L11.25,15.9285714 L11.25,17.5 L12.75,17.5 L12.75,15.9285714 Z M12,6.5 C10.3425,6.5 9,7.90642857 9,9.64285714 L9,9.64285714 L10.5,9.64285714 C10.5,8.77857143 11.175,8.07142857 12,8.07142857 C12.825,8.07142857 13.5,8.77857143 13.5,9.64285714 C13.5,10.075 13.335,10.4678571 13.0575,10.7507143 L13.0575,10.7507143 L12.1275,11.7407143 C11.5875,12.3142857 11.25,13.1 11.25,13.9642857 L11.25,13.9642857 L11.25,14.3571429 L12.75,14.3571429 C12.75,13.1785714 13.0875,12.7071429 13.6275,12.1335714 L13.6275,12.1335714 L14.3025,11.4107143 C14.73,10.9628571 15,10.3342857 15,9.64285714 C15,7.90642857 13.6575,6.5 12,6.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconHelp')(IconHelp);